import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light";
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../../constants"
import { GradientCard } from "../../components";
import { Trans, useTranslation } from "react-i18next";
import DegenrativeImage1 from '../../../../assets/images/svgs/identifyingGA/degenerative_01.png';
import DegenrativeImage2 from '../../../../assets/images/svgs/identifyingGA/degenerative_02.png';
import TransMsg from './transMessage';

const styles = {
    imageTags: {
        ...theme.typography.montseratBodyMedium,
        fontSize: "13px",
        color: "#00567C",
        pb: "10px"
    }
}
const IntermediateDisease = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))
    const intermediateDiseaseData = {
        title: t(TransMsg.INTERMEDIATE_DISEASE_TITLE),
        description: t(TransMsg.INTERMEDIATE_DISEASE_DESCRIPTION),
        imageUrl1: DegenrativeImage1,
        image1Description: "Image courtesy of Dr. Arshad Khanani",
        imageUrl2: DegenrativeImage2,
        image2Description: " Image courtesy of Dr. Arshad Khanani"
    }

    return (
        <Box textAlign={"left"} px="31px" pt={"40px"} pb="37px" sx={{ backgroundColor: "#F8F8F8" }} display="flex" flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
            <Box maxWidth={isMobileX ? "none" : EDUCATION_HUB_CONTENT_MAX_WIDTH} width={"100%"}>
                <Typography sx={{ ...theme.typography.components.sectionTitle, textAlign: "center" }}>
                    <Trans
                        i18nKey={intermediateDiseaseData.title}
                        components={{ br: <br /> }}
                    />
                </Typography>

                <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "24px", px: isMobileX ? "none" : "61px", textAlign: "center" }}>
                    <Trans
                        i18nKey={intermediateDiseaseData.description}
                        components={{ br: <br />, sup: <sup />, bold: <strong style={{ fontWeight: "700" }} /> }} />
                </Typography>

                <Box display={"flex"} pt={"24px"} justifyContent={"center"} flex={1}>
                    <Box>
                        <Box display={"flex"} gap={"16px"} flexWrap={"wrap"}>
                            <Box>
                                <Typography sx={styles.imageTags}>A</Typography>
                                <Box>
                                    <img src={intermediateDiseaseData.imageUrl1} alt="degenrative-image-1" style={{ maxWidth: "419px", maxHeight: "216px", width: "100%", height: "100%" }} />
                                </Box>
                                <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px", fontStyle: "italic" }}>
                                    {intermediateDiseaseData.image1Description}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography sx={styles.imageTags}>B</Typography>
                                <Box>
                                <img src={intermediateDiseaseData.imageUrl2} alt="degenrative-image-2" style={{ maxWidth: "419px", maxHeight: "283px", width: "100%", height: "100%" }} />
                                </Box>
                                <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px", fontStyle: "italic" }}>
                                    {intermediateDiseaseData.image2Description}
                                </Typography>
                            </Box>
                        </Box>
                        <Box>
                            <GradientCard
                                cardSx={{ mt: isMobileX ? "24px" : "-54px", maxWidth: "330px", p: isMobileX ? "31px 50px 60px 32px" : "32px 59px 81px 31px" }}
                                contentSx={{ textAlign: "left" }}
                                content={<Trans
                                    i18nKey={t(TransMsg.INTERMEDIATE_DISEASE_NOTES)}
                                    components={{ sup: <sup /> }} />}
                            />
                        </Box>
                    </Box>
                </Box>


            </Box>
        </Box>
    )
}

export default IntermediateDisease